import { AxiosInstance, AxiosRequestConfig } from 'axios';


const ENDPOINT = 'import/';

type ImportPayload = {
  filename: string;
  content: string;
}

type TransactionImportPayload = ImportPayload & {
  type_id: number;
  comment?: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  uploadQRCodes: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'qrcode/', payload, config),
  getQRCodesTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'qrcode/template/', config),
  uploadConditions: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'condition/', payload, config),
  getConditionsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'condition/template/', config),
  uploadTransactions: (payload: TransactionImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'transactions/', payload, config),
  getTransactionsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'transactions/template/', config),
  uploadUpdateOutlets: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'outlet/update/', payload, config),
  getUpdateOutletsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'outlet/update/template/', config),
  uploadNewOutlets: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'outlet/create/', payload, config),
  getNewOutletsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'outlet/create/template/', config),
  uploadPaidInstallations: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'installation_registry/', payload, config),
  getPaidInstallationsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'installation_registry/template/', config),
  uploadSalesSourceOutlets: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'sales_source_outlet/', payload, config),
  getSalesSourceOutletsTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'sales_source_outlet/template/', config),
  uploadServiceSetCheck: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'equipment_service/set_check/', payload, config),
  getServiceSetCheckTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'equipment_service/set_check/template/', config),
  uploadEquipmentEfficiency: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'equipment_efficiency/', payload, config),
  getEquipmentEfficiencyTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'equipment_efficiency/template/', config),
  uploadOutletRouteNumberLinkCreate: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'outlet_route_number_link/create/', payload, config),
  uploadOutletRouteNumberLinkDelete: (payload: ImportPayload) =>
    instance.post<ApiResponse<string>>(ENDPOINT + 'outlet_route_number_link/delete/', payload, config),
  getOutletRouteNumberLinkTemplate: () =>
    instance.get<ApiResponse<string>>(ENDPOINT + 'outlet_route_number_link/template/', config),
});
